export const FETCH_PRODUCT_DETAIL_REQUESTED = 'FETCH_PRODUCT_DETAIL_REQUESTED';
export const FETCH_PRODUCT_DETAIL_SUCCEEDED = 'FETCH_PRODUCT_DETAIL_SUCCEEDED';
export const MAP_CATEGORIES_TO_PRODUCT = 'MAP_CATEGORIES_TO_PRODUCT';
export const FETCH_PRODUCT_TEMPORARY_PRICE_REQUESTED = 'FETCH_PRODUCT_TEMPORARY_PRICE_REQUESTED';
export const FETCH_PRODUCT_TEMPORARY_PRICE_SUCCEEDED = 'FETCH_PRODUCT_TEMPORARY_PRICE_SUCCEEDED';
export const FETCH_PRODUCT_ALLOWED_TRANSITIONS_REQUESTED = 'FETCH_PRODUCT_ALLOWED_TRANSITIONS_REQUESTED';
export const FETCH_PRODUCT_ALLOWED_TRANSITIONS_SUCCEEDED = 'FETCH_PRODUCT_ALLOWED_TRANSITIONS_SUCCEEDED';
export const FETCH_PRODUCT_HISTORIES_REQUESTED = 'FETCH_PRODUCT_HISTORIES_REQUESTED';
export const FETCH_PRODUCT_HISTORIES_SUCCEEDED = 'FETCH_PRODUCT_HISTORIES_SUCCEEDED';
